import type { ReactNode } from 'react';
import { useCallback, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

export function usePortal() {
  const [targetRef, setTargetRef] = useState<HTMLDivElement | null>(null);

  const target = useMemo(() => <div ref={setTargetRef} />, []);

  const renderContent = useCallback(
    (children: ReactNode) => {
      if (!targetRef) return;
      return createPortal(children, targetRef);
    },
    [targetRef]
  );

  const value = useMemo(
    () => ({ target, renderContent, targetRef }),
    [target, renderContent, targetRef]
  );

  return value;
}

export type UsePortal = ReturnType<typeof usePortal>;
